import { questionAndAnswerSets } from "./jsonParsers/questions";
import { addRolesToQuestionSet, createQuestionSetFromSchema } from "./helper";
import { roles } from "./jsonParsers/roles";
import { json } from "d3";
import { getRoleFromJson } from "./jsonParsers/roles/helpers";

const QuestionSets = roles.map((role) => {
  role: createQuestionSetFromSchema(questionAndAnswerSets, role);
});

addRolesToQuestionSet(QuestionSets, roles, questionAndAnswerSets);

export default QuestionSets;
